import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connectRefinementList } from 'react-instantsearch/connectors'
import AlgoliaHelper from 'lib/AlgoliaHelper'
import { filter, find, some } from 'lodash'
import Dropdown from 'components/search/Dropdown'

const CategorySelectFilter = ({
  items,
  refine,
  initialItems,
  currentRefinement
}) => {
  const [categories, setCategories] = useState(
    AlgoliaHelper.mapFromAllCategories(initialItems, items, currentRefinement)
  )

  useEffect(() => {
    setCategories(
      AlgoliaHelper.mapFromAllCategories(initialItems, items, currentRefinement)
    )
  }, [items, initialItems, currentRefinement])

  const handleRefine = (item) => {
    let newRefinement

    if (item.isRefined) {
      // Remove the item from refinement
      newRefinement = filter(
        currentRefinement,
        (refinement) => refinement !== item.label
      )
    } else {
      // Add the item to refinement
      newRefinement = [...currentRefinement, item.label]
    }

    // Check if this item is a child category (not a parent)
    const isChildCategory = some(
      categories,
      (category) =>
        category.children &&
        category.children.some((child) => child.id === item.id)
    )

    // If this is a child category and its parent is active, remove the parent
    if (isChildCategory) {
      const parentCategory = find(
        categories,
        (category) =>
          category.children &&
          category.children.some((child) => child.id === item.id)
      )

      if (parentCategory && parentCategory.isRefined) {
        newRefinement = filter(
          newRefinement,
          (refinement) => refinement !== parentCategory.label
        )
      }
    }

    // If this is a parent category being toggled ON, remove its active children
    if (!isChildCategory && item.isRefined === false) {
      const parentCategoryBeingAdded = find(
        categories,
        (category) => category.id === item.id
      )

      if (parentCategoryBeingAdded && parentCategoryBeingAdded.children) {
        // Remove all children of this parent from refinement
        parentCategoryBeingAdded.children.forEach((child) => {
          newRefinement = filter(
            newRefinement,
            (refinement) => refinement !== child.label
          )
        })
      }
    }

    refine(newRefinement)
  }

  const getSelectedLabel = () => {
    if (currentRefinement && currentRefinement.length > 0) {
      if (currentRefinement.length === 1) {
        return currentRefinement[0]
      } else {
        return `${currentRefinement.length} catégories sélectionnées`
      }
    }
    return 'Catégories'
  }

  const isCategoryDisabled = (category) => {
    return !category.count || category.count <= 0
  }

  return (
    <Dropdown
      title={getSelectedLabel()}
      refined={currentRefinement && currentRefinement.length > 0}
      className="category-search-filter"
      selectClassName="category-select">
      <div className="category-select-container">
        {categories.map((category) => (
          <div key={category.id} className="category-group">
            <div
              className={`category-option parent-category-option ${
                category.isRefined ? 'refined' : ''
              } ${isCategoryDisabled(category) ? 'disabled' : ''}`}
              onClick={(e) => {
                if (!isCategoryDisabled(category)) {
                  handleRefine(category)
                }
              }}>
              <input
                type="checkbox"
                checked={category.isRefined}
                disabled={isCategoryDisabled(category)}
                onChange={() => {
                  if (!isCategoryDisabled(category)) {
                    handleRefine(category)
                  }
                }}
                onClick={(e) => e.stopPropagation()}
              />
              <span>{category.label} ({category.count})</span>
            </div>

            {category.children && category.children.length > 0 && (
              <div className="children-container">
                {category.children.map((subcategory) => {
                  const isDisabled = isCategoryDisabled(subcategory)
                  return (
                    <div
                      className={`category-option child-category-option ${
                        subcategory.isRefined ? 'refined' : ''
                      } ${isDisabled ? 'disabled' : ''}`}
                      key={subcategory.id}
                      onClick={(e) => {
                        if (!isDisabled) {
                          handleRefine(subcategory)
                        }
                      }}>
                      <input
                        type="checkbox"
                        checked={subcategory.isRefined}
                        disabled={isDisabled}
                        onChange={() => {
                          if (!isDisabled) {
                            handleRefine(subcategory)
                          }
                        }}
                        onClick={(e) => e.stopPropagation()}
                      />
                      <span>
                        {subcategory.label} ({subcategory.count})
                      </span>
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        ))}
      </div>
    </Dropdown>
  )
}

CategorySelectFilter.propTypes = {
  items: PropTypes.array,
  initialItems: PropTypes.array,
  currentRefinement: PropTypes.array,
  refine: PropTypes.func
}

export default connectRefinementList(CategorySelectFilter)
